import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-8ec0f12a")

_pushScopeId("data-v-8ec0f12a")
const _hoisted_1 = {
  key: 0,
  class: "hotspot-module-container"
}
const _hoisted_2 = { class: "cover-wrapper" }
const _hoisted_3 = {
  key: 0,
  class: "top-wrapper"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "buy-icon" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("span", null, "点击购买", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_HotspotContentList = _resolveComponent("HotspotContentList")

  return (_ctx.modules)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          (_ctx.modules.title)
            ? (_openBlock(), _createBlock("div", _hoisted_3, [
                _createVNode("span", null, _toDisplayString(_ctx.modules.title), 1)
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_HotspotContentList, {
            list: _ctx.modules.list,
            onAudiobgstop: _ctx.audiobgstop
          }, null, 8, ["list", "onAudiobgstop"])
        ]),
        _createVNode("div", {
          class: "buy-wrapper",
          onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.buy && _ctx.buy(...args)), ["stop","prevent"]))
        }, [
          _hoisted_4,
          _hoisted_5
        ])
      ]))
    : _createCommentVNode("", true)
})